module.exports = __webpack_public_path__ + "static/media/5.52029298.png";